import type { DateRangePickerProps } from '@aigc/antd';
import { DateRangePicker } from '@aigc/antd';
import { useCallback } from 'react';
import { TIME_RANGE_PRESETS } from '../model';

export interface TimeRangePickerProps {
  value: [number, number];
  onChange: (value: [number, number]) => void;
}

export const TimeRangePicker = ({ value, onChange }: TimeRangePickerProps) => {
  const dateValue: [Date, Date] = [new Date(value[0]), new Date(value[1])];

  const handleChange: DateRangePickerProps['onChange'] = useCallback(
    (dates: [Date | null, Date | null] | null) => {
      if (dates == null || dates[0] == null || dates[1] == null) {
        return; // 不允许清空
      }
      onChange([dates[0].getTime(), dates[1].getTime()]);
    },
    [onChange],
  );

  return (
    <DateRangePicker
      showTime
      allowClear={false}
      value={dateValue}
      onChange={handleChange}
      presets={TIME_RANGE_PRESETS}
    />
  );
};
